import React from 'react';
import { Modal, Button, Checkbox, Select, message } from 'antd';
import { connect } from 'react-redux';
import Item from 'antd/lib/list/Item';

const CheckboxGroup = Checkbox.Group;
const Option = Select.Option;

interface Props {
  visible: boolean;
  record: any;
  title: string;
  allList?: any;
  showModal: (data: any) => void;
  handleOk: (data: any) => void;
  handleCancel: (data: any) => void;
  perms?: any;
  changePerm: (data: any) => any;
  changeRoleType: (data: any) => any;
  roleList: any;
  getUserRole?: any;
}

class Modaled extends React.Component<Props> {
  state = {
    visible: false,
    checkedList: [],
    indeterminate: true,
    select: null,
    getUserRole: this.props.getUserRole,
  }

  onChange = (checkedList: any) => {

    let plainOptions = this.props.allList.map((item: any, index: number) => {
      return item.title
    })

    this.setState({
      checkedList,
      indeterminate: !!checkedList.length && (checkedList.length < plainOptions.length),
    });
  }

  handleOk = (e: any) => {
    let newPage = this.state.checkedList;
    let params = {
      id: this.props.record.id
    }
    let data = newPage;
    this.props.changePerm({data, params})
    .then(
      (res: any) => {
        if (!res.error) {
          message.success('修改权限成功')
        }
      }
    );
    this.props.handleOk(e)
  }

  handleOk2 = (e: any) => {
    let role = this.state.select ? this.state.select : this.props.record.roles[0];
    let params = {
      id: this.props.record.userId
    }
    let data = {
      roleValue: role
    }
    this.props.changeRoleType({params, data})
    .then(
      (res: any) => {
        if (!res.error) {
          message.success(`账号${this.props.record.userName}修改成功`)
        }
      }
    )
    this.props.handleOk(e)
  }

  handleChange = (value: any) => {
    this.setState({
      select: value,
      getUserRole: value
    })
  }

  handleCancel = (e: any) => {
    this.setState({
      select: null
    })
    this.props.handleCancel(e);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      getUserRole: nextProps.getUserRole
    })
  }


  render() {
    const data = this.props.record;
    let plainOptions = this.props.allList.map((item: any, index: number) => ({
      label: item.name,
      value: item.value
    }))

    let roleList = this.props.roleList.map((item: any, index: number) => {
        return (
          <Option key={item.roleValue} value={item.roleValue}>{item.roleName}</Option>
        )
    })

    const { getUserRole } = this.props;
    return (
      <div>
        <Modal
          title={this.props.title}
          visible={this.props.visible}
          onOk={this.props.title === '角色配置' ? this.handleOk : this.handleOk2}
          onCancel={this.handleCancel}
          destroyOnClose={true}
        >
          {
            this.props.title === '角色配置' ?
              (
                <div>
                  <h1>{data ? data.roleName : null}</h1>
                  <p style={{ fontWeight: 500 }}>权限范围</p>
                  <CheckboxGroup options={plainOptions} defaultValue={this.props.perms} onChange={this.onChange} />
                </div>
              )
              :
              (
                <div>
                  <p style={{ fontWeight: 500 }}>当前用户</p>
                  <h3>{data ? data.userName : null}</h3>
                  <p style={{ fontWeight: 500 }}>选择角色</p>
                  <div>
                    <Select value={this.state.getUserRole} style={{ width: 120 }} onChange={this.handleChange}>
                      {roleList}
                    </Select>
                  </div>
                </div>
              )
          }
        </Modal>
      </div>
    );
  }
}

export default Modaled